import { Outlet } from "react-router";
import { NavLink } from "react-router-dom";

export default function Rates() {
  const linkStyle = {
    display: "inline-block",
    padding: "4px",
    margin: "0px 30px 0px 0px",
    color: "#828282",
    fontSize: "15px",
    position: "relative",
  };
  const selectedLink = "!text-dark font-bold after:!w-full after:bg-[#2121F1] ";
  return (
    <div className="w-full font-Neurial h-full pt-5 px-5 pb-40 space-y-6">
      <div className="flex flex-col gap-5">
        <div className="font-bold text-[22px] text-[#070E05]">Settings</div>
        <div className="settings-box block whitespace-nowrap overflow-x-auto relative border-b-[1px] border-b-[#BDBDBD] py-2">
          <NavLink
            end
            to=""
            className={({ isActive }) => (isActive ? selectedLink : "")}
            style={linkStyle}
          >
            <div className="">Cryptocurrency (Buy)</div>
          </NavLink>
          <NavLink
            end
            to="/rates/sell-crypto"
            className={({ isActive }) => (isActive ? selectedLink : "")}
            style={linkStyle}
          >
            <div className="">Cryptocurrency (Sell)</div>
          </NavLink>
          <NavLink
            to="/rates/buy-giftcards"
            className={({ isActive }) => (isActive ? selectedLink : "")}
            style={linkStyle}
          >
            <div className="">Gift cards (Buy)</div>
          </NavLink>
          <NavLink
            to="/rates/sell-giftcards"
            className={({ isActive }) => (isActive ? selectedLink : "")}
            style={linkStyle}
          >
            <div className="">Gift cards (Sell)</div>
          </NavLink>
          {/* <NavLink
            to="/rates/platform-rate"
            className={({ isActive }) => (isActive ? selectedLink : "")}
            style={linkStyle}
          >
            <div className="">Platform Rate</div>
          </NavLink> */}
          {/* <NavLink
            to="/rates/shipping"
            className={({ isActive }) => (isActive ? selectedLink : "")}
            style={linkStyle}
          >
            <div className="">Shipping</div>
          </NavLink> */}
        </div>
        <Outlet />
      </div>
    </div>
  );
}
